import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Gates the protected shell. While the session is being restored we show a
 * full-screen spinner; unauthenticated users are redirected to /login with the
 * intended destination preserved so they land back where they were going.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex h-screen items-center justify-center bg-bg" aria-busy="true" aria-live="polite">
        <Spinner label="Loading your workspace…" color="primary" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
